import { MutationFunctionOptions, MutationHookOptions, MutationResult } from "@apollo/client";
import { useMutation } from "../../../hooks";
import { FetchResult } from "@apollo/client/link/core";
import { addToMatterAssumptionsCache } from "../../query";
import { newClientId } from "../../client/client-id-generator";
import {
  CreateAssumptionsMutation,
  CreateAssumptionsMutationVariables,
  AssumptionCreateInput,
} from "~/gql/graphql";
import { graphql } from "~/gql";

export const CREATE_ASSUMPTIONS = graphql(/* GraphQL */ `
  mutation createAssumptions($input: [AssumptionCreateInput!]!) {
    createAssumptions(input: $input) {
      id
      text
      order
      fromLibraryAssumptionId
    }
  }
`);

export type CreateAssumptionsMutationFunction = (
  matterId: number,
  assumptions: AssumptionCreateInput | AssumptionCreateInput[],
  options?: MutationFunctionOptions<CreateAssumptionsMutation, CreateAssumptionsMutationVariables>
) => Promise<FetchResult<CreateAssumptionsMutation>>;

export function useCreateAssumptionsMutation(
  options?: MutationHookOptions<CreateAssumptionsMutation, CreateAssumptionsMutationVariables>,
  order?: number
): [CreateAssumptionsMutationFunction, MutationResult<CreateAssumptionsMutation>] {
  const [mutationFunction, mutationResult] = useMutation(CREATE_ASSUMPTIONS, {
    errorPolicy: "none",
    ...(options || {}),
  });
  const createAssumptionsMutation: CreateAssumptionsMutationFunction = (
    matterId,
    inputs,
    options
  ) => {
    const assumptions = Array.isArray(inputs) ? inputs : [inputs];
    const optimisticAssumptions = assumptions.map((a) => ({
      ...a,
      __typename: "Assumption",
      id: newClientId(),
      order: order || -1,
      fromLibraryAssumptionId: null,
      // })) as createAssumptions_createAssumptions[];
    })) as CreateAssumptionsMutation["createAssumptions"];

    return mutationFunction({
      variables: { input: assumptions },
      optimisticResponse: {
        createAssumptions: optimisticAssumptions,
      },
      update(cache, { data }) {
        if (data?.createAssumptions?.length || 0 > 0) {
          addToMatterAssumptionsCache(cache, matterId, data!.createAssumptions);
        }
      },
      ...(options || {}),
    });
  };
  return [createAssumptionsMutation, mutationResult];
}
